import { REGEX, KEYWORDS, OPS_SORTED } from "../spec/tokens.js";

export function tokenize(input) {
    const tokens = [];
    const errors = [];
    let i = 0; let line = 1; let col = 1;

    const pos = () => ({ index: i, line, col });
    const advance = (n) => {
        for (let k = 0; k < n; k++) {
            if (input[i] === "\n") { line++; col = 1; } else { col++; }
            i++;
        }
    };
    const emit = (type, text, from, to, extra = {}) => tokens.push({ type, text, from, to, ...extra });

    const tryMatch = (re, typeMapper, { emitToken = true } = {}) => {
        re.lastIndex = i;
        const m = re.exec(input);
        if (!m) return false;
        const text = m[0];
        const from = pos();
        advance(text.length);
        const to = pos();
        if (emitToken) emit(typeMapper(re, text), text, from, to);
        return true;
    };

    const mapSimple = (re, text) => {
        switch (re) {
        case REGEX.lparen: return "LPAREN";
        case REGEX.rparen: return "RPAREN";
        case REGEX.lbrace: return "LBRACE";
        case REGEX.rbrace: return "RBRACE";
        case REGEX.dollar: return "DOLLAR";
        case REGEX.percent: return "PERCENT";
        case REGEX.listBracket: return "LIST_BRACKET";
        case REGEX.backtick: return "BACKTICK";
        case REGEX.number: return "NUMBER";
        case REGEX.alpha: return KEYWORDS.has(text) ? (text === "if" ? "KW_IF" : "KW_ELSE") : "ALPHA";
        case REGEX.comma: return "COMMA";
        default: return "UNKNOWN";
        }
    };

    while (i < input.length) {
        if (tryMatch(REGEX.ws, () => "WS", { emitToken: false })) continue;

        let opMatched = false;
        for (const op of OPS_SORTED) {
            op.lexeme.lastIndex = i;
            const m = op.lexeme.exec(input);
            if (m) {
                const text = m[0];
                const from = pos();
                advance(text.length);
                const to = pos();
                emit("OP", text, from, to, { opLexeme: text, opMeta: op.meta });
                opMatched = true;
                break;
            }
        }
        if (opMatched) continue;

        if (tryMatch(REGEX.lparen, mapSimple)) continue;
        if (tryMatch(REGEX.rparen, mapSimple)) continue;
        if (tryMatch(REGEX.lbrace, mapSimple)) continue;
        if (tryMatch(REGEX.rbrace, mapSimple)) continue;
        if (tryMatch(REGEX.dollar, mapSimple)) continue;
        if (tryMatch(REGEX.percent, mapSimple)) continue;
        if (tryMatch(REGEX.listBracket, mapSimple)) continue;
        if (tryMatch(REGEX.backtick, mapSimple)) continue;
        if (tryMatch(REGEX.comma, mapSimple)) continue;
        if (tryMatch(REGEX.number, mapSimple)) continue;
        if (tryMatch(REGEX.alpha, mapSimple)) continue;

        const from = pos();
        const ch = input[i];
        advance(1);
        const to = pos();
        emit("UNKNOWN", ch, from, to);
        errors.push({ message: `Unexpected character '${ch}'`, pos: from });
    }

    return { tokens, errors };
}
